'use strict';

var _ = require('lodash');
var SchedulerConfigFactory = function SchedulerConfigFactory($filter, constants, momentService, userPreferencesService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function SchedulerConfig(edited) {
    edited = edited || {};
    this.occurrence = getOccurrence(edited);
    this.timezone = getTimezone(edited);
    this.recurrence = edited.recurrence || false;
    this.recurrenceRepeatNumber = edited.recurrenceRepeatNumber || 1;
    this.repeatTimesNumber = edited.repeatTimesNumber || 1;
    this.calendar = edited.calendar || false;
    this.recurrenceInterval = getRecurrenceInterval(edited);
    this.calendarInterval = getCalendarInterval(edited);
    this.recurrenceRepeatOption = edited.recurrenceRepeatOption || constants.RECURRENCE.INDEFINITELY;
    this.startDate = transformDate(edited.startDate);
    this.repeatUntilDate = transformDate(edited.repeatUntilDate);
    if (edited.days) {
      this.selectedDay = getSelectedDay(edited.days, edited.recurrenceInterval);
      this.days = getDaysOfWeek(edited.days, edited.recurrenceInterval);
    } else {
      this.selectedDay = constants.DAYS_OF_MONTH[0];
    }
  }
  function getDaysOfWeek(days, interval) {
    if (interval === constants.CALENDAR_INTERVALS[0]) {
      return getDaysIndexesToStrings(days);
    }
    return [];
  }
  function getOccurrence(edited) {
    return edited.startDate || edited.recurrence ? constants.OCCURRENCE.LATER : constants.OCCURRENCE.NOW;
  }
  function getCalendarInterval(edited) {
    return _.includes(constants.CALENDAR_INTERVALS, edited.recurrenceInterval) ? edited.recurrenceInterval : constants.CALENDAR_INTERVALS[0];
  }
  function getRecurrenceInterval(edited) {
    return _.find(constants.RECURRENCE_INTERVALS, ['id', edited.recurrenceInterval]) || constants.RECURRENCE_INTERVALS[0];
  }
  function getSelectedDay(selectedDays, interval) {
    if (selectedDays.length === 1 && interval === constants.CALENDAR_INTERVALS[1]) {
      var id = selectedDays[0] - 1;
      if (id === -1) {
        id = 31;
      }
      return constants.DAYS_OF_MONTH[id];
    }
    return constants.DAYS_OF_MONTH[0];
  }
  function getTimezone(edited) {
    if (edited.timezone) {
      return edited.timezone;
    }
    var userTimeZoneData = userPreferencesService.getUserTimeZoneData();
    return userTimeZoneData && userTimeZoneData.code || undefined;
  }
  SchedulerConfig.prototype.shouldRunNow = function () {
    return this.occurrence === constants.OCCURRENCE.NOW;
  };
  SchedulerConfig.prototype.shouldRunLater = function () {
    return this.occurrence === constants.OCCURRENCE.LATER;
  };
  SchedulerConfig.prototype.withoutRecurrence = function () {
    return !(this.shouldRunLater() && this.recurrence);
  };
  SchedulerConfig.prototype.getSchedulerFormData = function (object) {
    object.startDate = this.shouldRunNow() ? '' : parseDateTime(this.startDate);
    object.recurrence = this.recurrence && this.shouldRunLater();
    object.timezone = this.timezone;
    if (object.recurrence) {
      object.calendar = this.calendar;
      object.recurrenceRepeatOption = this.recurrenceRepeatOption;
      if (object.calendar) {
        object.days = getDaysStringsToIndexes(this.days);
        object.recurrenceInterval = this.calendarInterval;
      } else {
        object.recurrenceRepeatNumber = this.recurrenceRepeatNumber;
        object.recurrenceInterval = this.recurrenceInterval.id;
      }
      if (object.recurrenceRepeatOption === constants.RECURRENCE.TIMES) {
        object.repeatTimesNumber = this.repeatTimesNumber;
      }
      if (object.recurrenceRepeatOption === constants.RECURRENCE.UNTIL) {
        object.repeatUntilDate = parseDateTime(this.repeatUntilDate);
      }
      if (object.recurrenceInterval === constants.CALENDAR_INTERVALS[1]) {
        object.days = [this.selectedDay.id];
      }
    }
    return object;
  };
  function parseDateTime(utcDateTime) {
    if (utcDateTime === undefined || utcDateTime === '') {
      return utcDateTime;
    }
    var utcDate = utcDateTime.startOf('minute');
    return rmMomentFormat(utcDate, 'DATE_TIME_MILLISECONDS_ISO');
  }
  function transformDate(date) {
    return date ? momentService.of(date, momentService.FIELD.DATA_EXTRACT, momentService.FORMAT.DATE_TIME_ISO) : '';
  }
  function getDaysStringsToIndexes(selectedDays) {
    return _.map(selectedDays, function (d) {
      return days.indexOf(d) + 1;
    });
  }
  function getDaysIndexesToStrings(selectedDays) {
    return _.map(selectedDays, function (d) {
      return days[d - 1];
    });
  }
  return SchedulerConfig;
};
SchedulerConfigFactory.$inject = ['$filter', 'DataExtractConstants', 'MomentService', 'UserPreferencesService'];
module.exports = SchedulerConfigFactory;